export const fr = {
  actionCard: {
    titles: {
      upcoming_event: 'Événement à venir',
      unpublished_event: 'Brouillon incomplet',
      pending_feedback: 'Rétroaction requise',
      upcoming_created_event: 'Événement créé à venir',
      upcoming_requested_event: 'Événement demandé à venir'
    },
    descriptions: {
      upcoming_event: '{{eventName}} le {{date}}',
      unpublished_event: 'Terminez la création de votre événement',
      pending_feedback: 'Soumettez une rétroaction pour {{eventName}}',
      upcoming_created_event: '{{eventName}} le {{date}}',
      upcoming_requested_event: '{{eventName}} le {{date}}'
    },
    notifications: {
      header: 'Notifications',
      view_all: 'Voir tout',
      hide_all: 'Masquer tout',
      empty_state: 'Aucune nouvelle notification'
    },
      actionCard: {
    titles: {
      upcoming_event: 'Événement à venir',
      unpublished_event: 'Brouillon incomplet',
      pending_feedback: 'Rétroaction requise',
      upcoming_created_event: 'Événement créé à venir',
      upcoming_requested_event: 'Événement demandé à venir',
      pending_verification: 'Vérification requise'
    },
    descriptions: {
      upcoming_event: '{{eventName}} le {{date}}',
      unpublished_event: 'Terminez la création de votre événement',
      pending_feedback: 'Soumettez une rétroaction pour {{eventName}}',
      upcoming_created_event: '{{eventName}} le {{date}}',
      upcoming_requested_event: '{{eventName}} le {{date}}',
      pending_verification: 'Complétez la vérification de votre profil'
    },
    notifications: {
      header: 'Notifications',
      view_all: 'Voir tout',
      hide_all: 'Masquer tout',
      empty_state: 'Aucune nouvelle notification',
      mark_as_read: 'Tout marquer comme lu',
    }
  }
  }
}